import Vue from 'vue';
import { abilitiesPlugin } from '@casl/vue';
import { Ability } from '@casl/ability';

export const ability = new Ability([]);

Vue.use(abilitiesPlugin, ability, {
  useGlobalProperties: true,
});
